

import moment from 'moment'

export const Login = {
    login:"",
    senha: "",
}

export const Usuario = {
    idUsuario:undefined, 
    idParceiro: 0, 
    nomeUsuario:"",
    email: "",
    login:"", 
    senha: "", 
    telefone:0, 
    timezoneParceiro:  moment().format(),     
}

export const Auth = {
    nome: "", 
    token: "",
}

const Endereco = {
    uf:"",
    cidade:"",
    ibge:0,
    rua:"",
    bairro:"",
    cep:0,
    complement:"",
    numero:"",
}

export const Servico = {
    idServico: undefined, 
    nomeServico: "", 
}

export const Parceiro = {
    idParceiro: undefined, 
    nomeParceiro: "",
    email:"",
    cpfCnpj:0,
    telefones:"",
    nomeResponsavel:"",
    telefoneParaReberSms:0,
    endereco: Endereco,
    logoParceiro:"",

}

export const Motorista = {
    idMotorista: undefined, 
    nomeMotorista: "",
    email:"",    
    senha:"",
    telefone:"",
}

export const Promocao = {
     idPromocao: undefined,     
     idParceiro:0, 
     idServico:0,
     nomeDoServico:"", 
     nomeDoParceiro:"",
     timezoneParceiro:  moment().format(),    
     enderecoParceiro: Endereco, 
}

 

export const Cupom = {
    idCupom: undefined,
    idParceiro: 0, 
    idMotorista: 0, 
    comentarioDoMotorista: "",
    descontoDinheiro:0, 
    descontoCartao:0, 
    descontoDebito:0, 
    formaPagamento: undefined, 
    timezoneMotorista: moment().format(),
    enderecoParceiro: Endereco
}

export const CupomDoParceiro= {
    ...Cupom    
}

export const CupomDoMotorista = {
    ...Cupom
}

export const Indicacao = {
    idIndicacao:undefined, 
    nomeParceiro: "", 
    nomeResponsavel:"", 
    telefoneParceiro: 0 , 
    enderecoParceiro: "", 
    timezoneMotorista: moment().format(), 

}

export function formaPagamento(formaPagamento){

    switch(formaPagamento){
        case 1:
            return  "Dinheiro"             
        case 2:
            return "Cartão de crédito"
                
        case 3:
            return "Cartão de débito"
            
    }

}

export function statusIndicacao(status){

    switch(status){
        case 1:
            return  "Aguardando contato"             
        case 2:
            return "Parceiro cadastrado"
                
        case 3:
            return "Cartão de débito"
            
    }

}